import { render, staticRenderFns } from "./PlanSteps.vue?vue&type=template&id=3be31b18"
import script from "./PlanSteps.vue?vue&type=script&lang=js"
export * from "./PlanSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports